import { trans } from '@elements/translation';
import type { SerializedOffer } from '@models/offer.ts';
import { Requests } from '@tools/requests';
import { URL_XHR_OFFER_EDIT, URL_XHR_OFFERS } from '@tools/routes/routes';
import { Logger } from '@tools/logger/logger';
import { flashBagError, flashBagSuccess } from '@tools/flashbag';

interface getOffersResponse {
  total: number;
  offers: SerializedOffer[];
}

export const getOffers = async (params: URLSearchParams): Promise<getOffersResponse | null> => {
  try {
    const response = await Requests.get(`${URL_XHR_OFFERS}?${params.toString().replace(/%2C/g, ',')}`);
    if (response.status === 200) {
      return {
        total: response.data.nb_records,
        offers: response.data.offers.map((offer: SerializedOffer) => ({ ...offer, address_name: offer.address?.name })),
      } as getOffersResponse;
    }
  } catch (err) {
    Logger.error(err);
    flashBagError();
  }
  return null;
};

export const saveOffers = async (offers: SerializedOffer[]): Promise<boolean> => {
  try {
    await Requests.post(URL_XHR_OFFER_EDIT, { offers }, { emulateJSON: true });
    flashBagSuccess(trans('offer.save'));
    return true;
  } catch (err) {
    flashBagError(trans('offer.save_fail'));
  }
  return false;
};
